import { Controller } from "stimulus";

export default class extends Controller {
  declare inputTarget: HTMLInputElement;

  static get targets() {
    return ["input"];
  }

  public connect() {
    if (typeof Storage !== "undefined") {
      // TODO: migrate away from DataMaps to Values
      // https://web.archive.org/web/20200807015522if_/https://stimulusjs.org/reference/data-maps
      // https://stimulus.hotwired.dev/reference/values
      const val = sessionStorage.getItem(this.data.get("key") || "unset-key");
      this.inputTarget.value = val || "";
    }
  }
}
